import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AppRoutes from "../../../common/routes";
import "../../../assets/css/dashboard.css";
import TopNav from "../../../components/top-nav";
import { _get_profile } from "../../../common/axios_services";

const SecuritySettings = () => {
  const Navigate = useNavigate();
  const [smsVerified, setSmsVerified] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkProfile = async () => {
      try {
        const res = await _get_profile();
        const user = res?.data?.data || res?.data;
        if (user) {
          setSmsVerified(!!user.smsVerified);
        }
      } catch (err) {
      } finally {
        setLoading(false);
      }
    };
    checkProfile();
  }, []);

  return (
    <div className="profile-display settings-display min-h-screen bg-white">
      <TopNav title="Security Settings" hideRightIcon />
      <div className="display-main-content pt-20">
        <div className="settings-detail-summary">
          <div className="settings-list-display">
            <div className="settings-list">
              <div className="settings-inner-list">
                <div>
                  <ul>
                    <li>
                      <Link to="/sms-verification">
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          <p style={{ margin: 0 }}>SMS Verification</p>
                          {!loading && (
                            smsVerified ? (
                              <span style={{ backgroundColor: "#000", color: "#fff", fontSize: "11px", padding: "2px 8px", borderRadius: "12px", fontWeight: "600" }}>Verified</span>
                            ) : (
                              <span style={{ backgroundColor: "#f3f4f6", color: "#000", border: "1px solid #000", fontSize: "11px", padding: "2px 8px", borderRadius: "12px", fontWeight: "600" }}>Verify Now</span>
                            )
                          )}
                        </div>
                        <ion-icon name="chevron-forward-outline"></ion-icon>
                      </Link>
                    </li>
                    <li>
                      <Link to={AppRoutes.update_password}>
                        <p>Update Password</p>
                        <ion-icon name="chevron-forward-outline"></ion-icon>
                      </Link>
                    </li>
                    <li>
                      <Link to={AppRoutes.update_email}>
                        <p>Update Email</p>
                        <ion-icon name="chevron-forward-outline"></ion-icon>
                      </Link>
                    </li>
                    <li>
                      <Link to={AppRoutes.update_login_pin}>
                        <p>Update Login PIN</p>
                        <ion-icon name="chevron-forward-outline"></ion-icon>
                      </Link>
                    </li>
                    <li>
                      <Link to={AppRoutes.update_trans_pin}>
                        <p>Update Transaction PIN</p>
                        <ion-icon name="chevron-forward-outline"></ion-icon>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecuritySettings;
